<div *ngIf="message()" class="xp-drop-zone__message">{{ message() }}</div>
<div *ngIf="errorVisible()" class="xp-drop-zone__error">
	<img *ngIf="errorIconSrc()" class="xp-drop-zone__error-icon" [src]="errorIconSrc()" alt="" />
	<span *ngIf="errorTitle()" class="xp-drop-zone__error-title">{{ errorTitle() }}</span>
	<span *ngIf="errorLabel()" class="xp-drop-zone__error-text">{{ errorLabel() }}</span>
</div>
<button *ngIf="!showProgress() && browseText()"
        xpButton
        type="button"
        class="xp-drop-zone__browse"
        [variant]="browseVariant()"
        [disabled]="disabled()"
        (click)="browse()">{{ browseText() }}</button>
<div *ngIf="showProgress()" class="xp-drop-zone__progress">
	<mat-progress-bar [mode]="progressMode()" [value]="progress()"></mat-progress-bar>
	<span *ngIf="progressMode() === 'determinate'" class="xp-drop-zone__percent">{{ progress() }}% Complete</span>
	<button *ngIf="progressMode() === 'determinate'"
	        xpButton
	        type="button"
	        class="xp-drop-zone__cancel"
	        variant="text"
	        (click)="cancel.emit()">{{ cancelLabel() }}</button>
</div>
<ng-content></ng-content>
<input #fileInput
       class="xp-drop-zone__input"
       type="file"
       [attr.accept]="accept() || null"
       [multiple]="multiple()"
       (change)="onFilePicked($event)" />
